(ns app.front.view.group.admin.archive-on-finish-select
  "Component for the admin to select per category whether the workspace should be archived upon 'set finish'"
  (:require [app.domain.group.config.model :as config-model]
            [app.front.ui.select :as ui-select]
            [app.front.view.group.admin.subs :as gas]
            [core.front.event :refer [>evt]]))


(defn archive-on-finish-selector [{:keys [ptc-id permit-type category-config tr selected-settings]}]
  (let [value           (:group.config/archive-on-finish category-config)
        config-id       (:db/id category-config)
        effective-value (or (get-in selected-settings [config-id :group.config/archive-on-finish])
                            value
                            config-model/default-archive-on-finish)
        on-change-fn    (fn [new-value]
                          (>evt [::gas/update-ptc-group-config-changes
                                 ptc-id
                                 config-id
                                 #(if (= new-value value)
                                    (dissoc % :group.config/archive-on-finish)
                                    (assoc % :group.config/archive-on-finish new-value))]))]
    [:div.mb-4 {:on-click #(.stopPropagation %)}
     [ui-select/select
      {:id           (str "archive-on-finish-" permit-type "-" config-id)
       :label-text   (tr [:group.config/archive-on-finish])
       :required     true
       :values       config-model/archive-on-finish-choice
       :val->str     (comp tr vector)
       :allow-empty? false
       :on-change    on-change-fn
       :value        effective-value}]]))
